const BASE_URL = "https://static.neshan.org";
const DEFAULT_URL = `${BASE_URL}/sdk/openlayers/5.3.0/ol.js`;
const DEFAULT_URL_STYLE = `${BASE_URL}/sdk/openlayers/5.3.0/ol.css`;

export default (onLoad: any, onError: any) => {
    const createScript = () => {

        const styleOL = document.getElementById("style-ol");
        styleOL && styleOL.remove();

        const scriptOL = document.getElementById("script-ol");
        scriptOL && scriptOL.remove();

        const style = document.createElement("link");
        style.href = DEFAULT_URL_STYLE;
        style.rel = "stylesheet";
        style.setAttribute("id", "style-ol");
        document.head.appendChild(style);

        const script = document.createElement("script");
        script.src = DEFAULT_URL;
        script.setAttribute("defer", "defer");
        script.setAttribute("id", "script-ol");
        script.onload = () => onLoad();
        script.onerror = () => onError();
        document.head.appendChild(script);
    };

    return createScript();
};
